<div class="nc-color-picker">
    <!--触发器-->
    <div class="nc-color-picker-block" [ngClass]="'block-' + ncSize" (click)="blockClick()">
        <div class="nc-color-picker-block-inner" [ngStyle]="{'background-color': ncValue}"></div>
    </div>

    <!--弹出面板-->
    <div class="nc-color-picker-panel" [hidden]="!panelShow" ncClickOutside (ncClickOut)="clickOut()">
        <!-- 颜色面板 -->
        <div class="div-panel">
            <div id="colorPanel" class="color-panel" [ngStyle]="{'background-color': 'rgb(' + hueColor + ')'}"></div>
            <div id="divPicker" class="div-picker"></div>
        </div>
        <!--柱状条-->
        <div class="slider-panel">
            <div>
                <!-- 色相柱 -->
                <div class="div-color">
                    <div id="colorBar" class="color-bar"></div>
                    <div id="divSlider" class="div-slider" [ngStyle]="{'background-color': 'rgb(' + hueColor + ')'}">
                    </div>
                </div>
                <!-- 透明柱状 -->
                <div class="div-alpha">
                    <div id="alphaBar" class="alpha-bar"
                        [ngStyle]="{'background': 'linear-gradient(to right, rgba(255, 0, 4, 0), rgb(' + rgb[0] + ',' + rgb[1] + ','+ rgb[2] + '))'}">
                    </div>
                    <div id="divAlphaSlider" class="div-slider"
                        [ngStyle]="{'background-color': 'rgba(' + rgb[0] + ',' + rgb[1] + ','+ rgb[2] + ',' + alpha  + ')'}">
                    </div>
                </div>
            </div>
            <!--color展示-->
            <div class="color-show">
                <div class="color-show-block"
                    [ngStyle]="{'background-color': 'rgba(' + rgb[0] + ',' + rgb[1] + ','+ rgb[2] + ',' + alpha  + ')'}">
                </div>
            </div>
        </div>
        <!--值展示-->
        <div class="result-panel">
            <div class="result-row">
                <div class="result-title">RGBA</div>
                <div class="result-input">
                    <input class="nc-input-number" style="width: 42px;" type="number" [(ngModel)]="rgb[0]" [min]="0"
                        [max]="255" step="1" (ngModelChange)="rgbChange()">

                    <input class="nc-input-number" style="width: 42px;" type="number" [(ngModel)]="rgb[1]" [min]="0"
                        [max]="255" step="1" (ngModelChange)="rgbChange()">

                    <input class="nc-input-number" style="width: 42px;" type="number" [(ngModel)]="rgb[2]" [min]="0"
                        [max]="255" step="1" (ngModelChange)="rgbChange()">

                    <input class="nc-input-number" style="width: 42px;" type="number" [(ngModel)]="alpha" [min]="0"
                        [max]="1" step="0.01" (ngModelChange)="alphaChange()">
                </div>
            </div>
            <div class="result-row">
                <div class="result-title">HEXA</div>
                <div class="result-input">
                    <input class="nc-input nc-input-sm" placeholder="Basic usage" [(ngModel)]="hexa"
                        (ngModelChange)="hexChange()">
                </div>
            </div>
        </div>

        <!--调试代码-->
        <!-- <div style="margin-top: 20px;">rgba:{{rgb[0] + ',' + rgb[1] + ','+ rgb[2] + ',' + alpha}}</div>
        <div>hexa:{{hexa}}</div>
        <div>hsv(选取,h:0-360):{{hsv.hue + ',' + hsv.saturation + ',' + hsv.value}}</div>
        <div>hsv(rgb转,h:0-100):{{rgbToHsv(rgb[0],rgb[1],rgb[2])}}</div> -->
    </div>
</div>